import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import './CatalogNavbar.scss';
import SortBy from 'components/SortBy/SortBy';


type Props = {
  title: string;
  option?: ReactElement
  input?: ReactElement
  showSortBy?: boolean
}
const CatalogNavbar: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="catalog-navbar-container">
      <div className="breadcrumbs">
        {t(props.title)}
      </div>
      {props.showSortBy ? <SortBy /> : null}
      <div className="input">{props.input}</div>
      <div className="options">{props.option}</div>
    </div>
  );
};

export default CatalogNavbar;